import moment from 'moment/min/moment-with-locales';
import 'moment/locale/ru';
import { orderBy } from 'lodash';

// Общая логика «категорий» соло-программ (BigSolo).
// Используется: pages/event/plashki/soloUsers/soloBig.jsx (список участников),
// pages/event/plashki/bigsolo_programm (плашка программы), pages/event/components/bigSolo (админка).

/**
 * Фолбэк-набор категорий: применялся, когда в настройках события ещё не было
 * BigSolo.categorys. Оставлен как есть (вместе с историческими опечатками),
 * чтобы НЕ менять поведение старых соло-соревнований.
 */
export const DEFAULT_BIG_SOLO_CATEGORYS = {

    1: { id: 1, title: "До 10 лет / НОВИЧКИ", ageFrom: 0, ageTo: 9, gender: 2, tier: 1 },
    2: { id: 2, title: "До 10 лет / БАЗОВОЕ", ageFrom: 0, ageTo: 9, gender: 2, tier: 2 },

    3: { id: 3, title: "10 - 13 лет Девочки / НОВИЧКИ", ageFrom: 10, ageTo: 13, gender: 0, tier: 1 },
    4: { id: 4, title: "10 - 13 лет Мальчики / НОВИЧКИ", ageFrom: 10, ageTo: 13, gender: 0, tier: 1 },
    5: { id: 5, title: "10 - 13 лет Девочки / БАЗОВОЕ", ageFrom: 10, ageTo: 13, gender: 0, tier: 2 },
    6: { id: 6, title: "10 - 13 лет Мальчики / БАЗОВОЕ", ageFrom: 10, ageTo: 13, gender: 1, tier: 2 },
    7: { id: 7, title: "10 - 13 лет Девочки / ПРО", ageFrom: 10, ageTo: 13, gender: 0, tier: 3 },
    8: { id: 8, title: "10 - 13 лет Мальчики / ПРО", ageFrom: 10, ageTo: 13, gender: 1, tier: 3 },

    9: { id: 9, title: "14 - 16 лет Девушки / НОВИЧКИ", ageFrom: 14, ageTo: 16, gender: 0, tier: 1 },
    10: { id: 10, title: "14 - 16 лет Юноши / НОВИЧКИ", ageFrom: 14, ageTo: 16, gender: 1, tier: 1 },
    11: { id: 11, title: "14 - 16 лет Девушки / БАЗОВОЕ", ageFrom: 14, ageTo: 16, gender: 0, tier: 2 },
    12: { id: 12, title: "14 - 16 лет Юноши / БАЗОВОЕ", ageFrom: 14, ageTo: 16, gender: 1, tier: 2 },
    13: { id: 13, title: "14 - 16 лет Девушки / ПРО", ageFrom: 14, ageTo: 16, gender: 0, tier: 3 },
    14: { id: 14, title: "14 - 16 лет Юноши / ПРО", ageFrom: 14, ageTo: 16, gender: 1, tier: 3 },

    15: { id: 15, title: "17+ лет Женщины / НОВИЧКИ", ageFrom: 17, ageTo: 29, gender: 0, tier: 1 },
    16: { id: 16, title: "17+ лет Мужчины / НОВИЧКИ", ageFrom: 17, ageTo: 29, gender: 1, tier: 1 },
    17: { id: 17, title: "17+ лет Женщины / БАЗОВОЕ", ageFrom: 17, ageTo: 29, gender: 0, tier: 2 },
    18: { id: 18, title: "17+ лет Мужчины / БАЗОВОЕ", ageFrom: 17, ageTo: 29, gender: 1, tier: 2 },
    19: { id: 19, title: "17+ лет Женщины / ПРО", ageFrom: 17, ageTo: 29, gender: 0, tier: 2 },
    20: { id: 20, title: "17+ лет Мужчины / ПРО", ageFrom: 17, ageTo: 29, gender: 1, tier: 2 },

    21: { id: 21, title: "30+ лет Женщины / НОВИЧКИ", ageFrom: 30, ageTo: 99, gender: 0, tier: 1 },
    22: { id: 22, title: "30+ лет Мужчины / НОВИЧКИ", ageFrom: 30, ageTo: 99, gender: 1, tier: 1 },
    23: { id: 23, title: "30+ лет Женщины / БАЗОВОЕ", ageFrom: 30, ageTo: 99, gender: 0, tier: 2 },
    24: { id: 24, title: "30+ лет Мужчины / БАЗОВОЕ", ageFrom: 30, ageTo: 99, gender: 1, tier: 2 },
    25: { id: 25, title: "30+ лет Женщины / БАЗОВОЕ", ageFrom: 30, ageTo: 99, gender: 0, tier: 3 },
    26: { id: 26, title: "30+ лет Мужчины / БАЗОВОЕ", ageFrom: 30, ageTo: 99, gender: 1, tier: 3 }
}

/** BigSolo из настроек события (или null) */
export const getBigSolo = (Event) => {
    const SettingsObj = (Event && Event.SettingsObj) || {};
    const ChallengeSettings = SettingsObj.ChallengeSettings;
    return (ChallengeSettings && ChallengeSettings.BigSolo) || null;
}

/** Дата события пригодна к разбору (в проекте встречаются строки-заглушки) */
export const isEventDateValid = (Date) => {
    return !!Date && Date !== 'null' && Date !== 'undefined' && Date !== 'invalid data';
}

/**
 * Возраст участника НА ДАТУ МЕРОПРИЯТИЯ (а не на сегодня).
 * Если дата события пустая/битая — считаем на сегодня (как раньше).
 */
export const getAgeAtDate = (BirthDay, EventDate) => {
    if (!BirthDay) return null;

    const Birth = moment(BirthDay, 'DD.MM.YYYY');
    if (!Birth.isValid()) return null;

    const Base = isEventDateValid(EventDate) ? moment(EventDate, 'DD.MM.YYYY') : moment();
    if (!Base.isValid()) return null;

    return Base.diff(Birth, 'years', false);
}


/** Категории события массивом, отсортированные по времени (как было: orderBy(categorys, 'time')) */
export const getCategorys = (BigSolo) => {
    const categorys = (BigSolo && BigSolo.categorys) || DEFAULT_BIG_SOLO_CATEGORYS;
    return orderBy(categorys, 'time');
}

/** Категории в виде массива, отсортированного по id (для админки) */
export const getCategorysById = (BigSolo) => {
    const categorys = (BigSolo && BigSolo.categorys) || {};
    return Object.keys(categorys)
        .map(key => categorys[key])
        .sort((a, b) => Number(a.id) - Number(b.id));
}

/** Категория по её id */
export const getCategoryById = (BigSolo, categoryId) => {
    if (!categoryId) return null;
    return getCategorysById(BigSolo).find(x => String(x.id) === String(categoryId)) || null;
}

/**
 * competitionId (solo_big_competition.Id), к которому привязан участник этой категории.
 * Новая схема: id лежит в самой категории (category.competitionId).
 * Фолбэк: BigSolo.competitions[category.tier] — для старых событий.
 */
export const getCategoryCompetitionId = (BigSolo, category) => {
    if (!category) return null;
    if (category.competitionId) return category.competitionId;
    const competitions = (BigSolo && BigSolo.competitions) || {};
    return competitions[category.tier] || null;
}

const matchCategory = (categorys, { age, gender, tier, withTier }) => {
    for (let i = 0; i < categorys.length; i++) {
        const category = categorys[i];
        if (!(age >= Number(category.ageFrom) && age <= Number(category.ageTo))) continue;
        if (!(Number(category.gender) === 2 || Number(category.gender) === Number(gender))) continue;
        if (withTier && String(category.tier) !== String(tier)) continue;
        return category;
    }
    return null;
}

/**
 * ГЛАВНАЯ функция: в какую категорию попадает участник.
 *
 * 1. org-параметр (org_category из допусков) — в приоритете, остальное не считаем;
 * 2. авто: возраст (на дату события) + пол + tier участника;
 * 3. если не нашли и включён BigSolo.tierFallback — ещё раз, только возраст + пол;
 * 4. если и тут нет — категории нет (участник не попадает в списки).
 *
 * Возвращает { category, source }: source = 'org' | 'tier' | 'age' | null
 */
export const resolveParticipatorCategory = ({ BigSolo, age, gender, tier, orgCategoryId }) => {

    if (!BigSolo) return { category: null, source: null };

    const categorys = getCategorys(BigSolo);

    // 1. Организатор перенёс вручную
    if (orgCategoryId) {
        const orgCategory = categorys.find(x => String(x.id) === String(orgCategoryId));
        if (orgCategory) return { category: orgCategory, source: 'org' };
    }

    // 2. Авто-подбор работает, если он вообще включён у события
    const autoMode = !!(BigSolo.categorysByDate || BigSolo.tierFallback);
    if (!autoMode) return { category: null, source: null };
    if (age === null || age === undefined) return { category: null, source: null };

    // 2.1 возраст + пол + tier
    const byTier = matchCategory(categorys, { age, gender, tier, withTier: true });
    if (byTier) return { category: byTier, source: 'tier' };

    // 2.2 мягкий режим: возраст + пол (tier игнорируем)
    if (BigSolo.tierFallback) {
        const byAge = matchCategory(categorys, { age, gender, tier, withTier: false });
        if (byAge) return { category: byAge, source: 'age' };
    }

    return { category: null, source: null };
}

/** Строка допуска организатора (org_category) для пользователя — нужна админке для замены */
export const getOrgCategoryRow = (ParticipatorsData, UserId) => {
    if (!ParticipatorsData || !ParticipatorsData[UserId]) return null;
    return ParticipatorsData[UserId].find(x => x.Type === 'org_category' && x.Accept !== 'decline') || null;
}

/** Значение org_category (id категории, куда участника перенёс организатор) или null */
export const getOrgCategoryId = (ParticipatorsData, UserId) => {
    const row = getOrgCategoryRow(ParticipatorsData, UserId);
    if (!row) return null;
    const id = Number(row.Value);
    return id > 0 ? id : null;
}

/** tier участника из participators.Settings */
export const getParticipatorTier = (Participator) => {
    if (!Participator || !Participator.Settings) return null;
    try {
        const SettingsObj = JSON.parse(Participator.Settings);
        return SettingsObj ? SettingsObj.tier : null;
    } catch (e) {
        return null;
    }
}

/** Подпись категории для селектов админки */
export const getCategoryLabel = (category, competitionTitle) => {
    if (!category) return '';
    const genderName = Number(category.gender) === 2 ? 'любой' : (Number(category.gender) === 1 ? 'муж' : 'жен');
    let label = `#${category.id} ${category.title} (${category.ageFrom}-${category.ageTo}, ${genderName})`;
    if (category.time) label += ` ${category.time}`;
    if (competitionTitle) label += ` → ${competitionTitle}`;
    return label;
}
